export default __webpack_public_path__ + "static/spacer_footer_bg-dd78a8265752f9b97e0737890cad74d3.jpg";